import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractForm } from '@core/forms/form';


export enum ProgramNumberOfTripsFormField {
    Name = 'name',
    TrfIdArr = 'trfIdArr',
    OrgId = 'orgId',
    PrgType = 'prgType',
}

export interface ProgramNumberOfTripsFormModel {
    [ProgramNumberOfTripsFormField.Name]: FormControl<string>;
    [ProgramNumberOfTripsFormField.PrgType]: FormControl<string>;
    [ProgramNumberOfTripsFormField.TrfIdArr]: FormControl<number[]>;
    [ProgramNumberOfTripsFormField.OrgId]: FormControl<number>;
}

@Injectable()
export class ProgramNumberOfTripsFormService extends AbstractForm<ProgramNumberOfTripsFormField, ProgramNumberOfTripsFormModel> {

    public createReactiveForm(): FormGroup<ProgramNumberOfTripsFormModel> {
        this.build({
            [ProgramNumberOfTripsFormField.Name]: new FormControl<string>(null, [Validators.required]),
            [ProgramNumberOfTripsFormField.TrfIdArr]: new FormControl<number[]>(null, [Validators.required]),
            [ProgramNumberOfTripsFormField.PrgType]: new FormControl<string>(null, [Validators.required]),
            [ProgramNumberOfTripsFormField.OrgId]: new FormControl<number>(null, [Validators.required]),
        });

        this.defineMechanics();

        return this.form;
    }


    private defineMechanics(): void {
    }
}
